/*
 * Utilizado provisoriamente para tratar o caso da data despadronizada - APMNTA-1320
 * Este método também existe no tema do parangaba com um comportamento específico.
 */

function getTicketDate(date) {
  return new Date(date);
}

/*
 * Utilizado provisoriamente para tratar o caso da data despadronizada - APMNTA-1320
 * Este método também existe no tema do parangaba com um comportamento específico.
 */

function getAdjustedDate(date) {
  return new Date(date);
}
